import dispatcher from "../Dispatcher/Dispatcher";
import config from "../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import PerformanceConstants from "../Constants/PerformanceAnalysisConstants";

class PerformanceAnalysis_Actions {
  getfilteredPerAnalysLogs(filterItem) {
    httpRequest(
      config.webServiceURL + "/PerformanceAnalysis/GetPerformanceLogs",
      "POST",
      JSON.stringify({
        ControllerName: filterItem.ControllerName,
        MethodName: filterItem.MethodName,
        Duration: filterItem.Duration,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deletePerfLog(Id) {
    httpRequest(
      config.webServiceURL + "/PerformanceAnalysis/" + Id,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PerformanceConstants.DEL_PERFORMANCE_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PerformanceConstants.DEL_PERFORMANCE_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  deleteMultiplePerformanceLog(filterItem) {
    httpRequest(
      config.webServiceURL + "/PerformanceAnalysis",
      "PUT",
      JSON.stringify({
        ControllerName: filterItem.ControllerName,
        MethodName: filterItem.MethodName,
        Duration: filterItem.Duration,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new PerformanceAnalysis_Actions();
